import { Cookies } from "@react-keycloak/ssr";

export class WebCookiePersistor extends Cookies {
  /**
   * We don´t want to reset the tokens when using this persistor
   * */
  resetTokens() {}
}
